import * as _ from 'underscore';
import { Modal } from './modal';
import { Event } from '../event';
import { IEvent } from '../../interfaces';
import { ConfirmModalOptions } from '../../interfaces/options';
import { DefaultConfirmModalOptions } from '../../const/defaultOptions';
import { Localization } from '../../compile';

export class ConfirmModal extends Modal {
	public message: KnockoutObservable<string>;
	public headLine: string;
	public displayHeadline: KnockoutObservable<boolean>;
	private confirmLabel: string;

	private clickConfirm: () => void;
	private onConfirmed: Event<void>;
	public get Confirmed(): IEvent<void> {
		return this.onConfirmed;
	}

	constructor(options?: ConfirmModalOptions) {
		super(
			(options = _.defaults({}, options, DefaultConfirmModalOptions, {
				title: Localization.Delete,
				message: Localization.Confirm.Delete.Singular,
				confirmLabel: Localization.Delete,
				headLine: null
			}))
		);

		this.headLine = options.headLine;
		this.confirmLabel = options.confirmLabel;
		this.message = ko.observable<string>(options.message);

		if (this.headLine == null || this.headLine == "") {
			this.displayHeadline = ko.observable<boolean>(false);
		}
		else {
			this.displayHeadline = ko.observable<boolean>(true);
        }

		this.onConfirmed = new Event<void>();

		this.clickConfirm = (): void => {
			this.onConfirmed.notify();
			this.close();
		};
	}

	//overwrite
	public open(
		confirmCallBack?: (...args: any[]) => any,
		caller?: any,
		abortCallBack?: (...args: any[]) => any
	) {
		let confirmed: boolean = false;

		let _confirmCallBack = (...args: any[]) => {
			confirmed = true;
			if (confirmCallBack && caller) {
				confirmCallBack.apply(caller, args);
			}
		};

		let clearCallBack = (...args: any[]) => {
			this.Confirmed.unsubscribe(_confirmCallBack);
			this.Closed.unsubscribe(clearCallBack);
			if (!confirmed && abortCallBack && caller) {
				abortCallBack.apply(caller, args);
			}
		};

		this.Confirmed.subscribe(_confirmCallBack);
		this.Closed.subscribe(clearCallBack);
		super.open();
	}
}
